import { apiClient } from '../utils/api';
import { UrlBuilder } from '../utils/urls';
import { DashboardKpiItem } from '../models';

export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  code?: number;
}

interface DashboardKpisResponse {
  status: string;
  message: string;
  record_id: number | null;
  kpis: any[];
}

class DashboardService {
  // Get dashboard KPIs for a user with token
  async getDashboardKpis(userId: number, token: string): Promise<ApiResponse<DashboardKpiItem[]>> {
    try {
      const response = await apiClient.postWithToken<DashboardKpisResponse>(
        UrlBuilder.dashboard.kpis(userId),
        token,
        {} // Empty body for POST request
      );

      if (response.success && response.data) {
        // Extract kpis array from the response
        const kpisData = response.data.kpis || [];
        return {
          success: true,
          data: kpisData
        };
      } else {
        return {
          success: false,
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'An unexpected error occurred'
      };
    }
  }
}

export const dashboardService = new DashboardService();